import React from 'react';
import { CTAButton } from './CTAButton';
import { CoffeeIcon } from 'lucide-react';
export function PriceJustification() {
  return <section className="bg-neutral-950 text-white py-20 px-4" data-id="element-143">
      <div className="max-w-3xl mx-auto text-center" data-id="element-144">
        <div className="flex justify-center mb-6" data-id="element-145">
          <div className="w-16 h-16 bg-gray-900 rounded-full flex items-center justify-center border border-gray-800" data-id="element-146">
            <CoffeeIcon className="w-8 h-8 text-amber-500" data-id="element-147" />
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-148">Why Only $6.36?</h2>

        <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed mb-12 text-left bg-gray-900/50 p-6 md:p-10 rounded-2xl border border-gray-800" data-id="element-149">
          <p data-id="element-150">
            We get it. You've seen the "miracle pills" and the "muscle
            influencers" lying to you online.
          </p>
          <p data-id="element-151">
            We priced this entire bundle at{' '}
            <strong className="text-amber-500" data-id="element-152">
              $6.36—the exact price of a single Starbucks Latte
            </strong>
            —to completely remove the risk for you.
          </p>
          <p data-id="element-153">
            We don't want price to be an excuse. We want you to see the real,
            biological results in your own body.
          </p>
          <p className="font-semibold text-white border-l-4 border-amber-500 pl-4 py-2" data-id="element-154">
            Once you wake up at 6:00 AM with 10/10 energy for the first time in
            years, we know you'll be a customer for life.
          </p>
        </div>

        <CTAButton text="I'M READY TO RECLAIM MY EDGE — $6.36" variant="secondary" className="w-full md:w-auto min-w-[320px]" data-id="element-155" />
      </div>
    </section>;
}